export default "__VITE_ASSET__BpCpD_oN__"